import type { ClassificationResult } from '@classification-testing/domain';
import type { DomainError } from '@core/domain';

/**
 * Classification state interface
 */
export interface ClassificationTestingState {
  isLoading: boolean;
  isFileUploading: boolean;
  errors: DomainError[] | null;
  classificationResults: Record<string, ClassificationResult[]>;
}

/**
 * Initial state for classification
 */
export const initialState: ClassificationTestingState = {
  isLoading: false,
  isFileUploading: false,
  errors: null,
  classificationResults: {},
};
